import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketing-footer',
  templateUrl: './marketing-footer.component.html',
  styleUrls: ['./marketing-footer.component.css']
})
export class MarketingFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
